import POPUP from "components/popup";
import IMAGEM from "components/imagem";
import './style.css';
import {formatDate, formatImage} from "components/formatos";


function DIALOGSORTEADODETALHE(props) {
    function Close() {
        props.setTrigger(false);
    }

    if (!props.trigger || !props.contemplado) return null;

    const validImages = props.contemplado.images?.filter(img => formatImage(img.url_foto)) || [];

    return (
        <POPUP
            trigger={props.trigger}
            setTrigger={Close}
        >
            <div className="sorteado-detalhe-container">
                <div className="sorteado-detalhe-header">
                    <div className="sorteado-detalhe-icon-badge">
                        <i className="fas fa-trophy"></i>
                    </div>
                    <h2>Detalhes do Ganhador</h2>
                    <p className="sorteado-detalhe-subtitle">Confira as informações do sorteio e da compra</p>
                </div>

                <div className="sorteado-detalhe-body">
                    <div className="info-grid">
                        <div className="info-item">
                            <i className="fas fa-user"></i>
                            <div>
                                <label>Contemplado</label>
                                <span>{props.contemplado.nome_sorteado}</span>
                            </div>
                        </div>

                        <div className="info-item">
                            <i className="fas fa-calendar-check"></i>
                            <div>
                                <label>Data do Sorteio</label>
                                <span>{formatDate(props.contemplado.data_sorteio)}</span>
                            </div>
                        </div>

                        <div className="info-item">
                            <i className="fas fa-store"></i>
                            <div>
                                <label>Estabelecimento</label>
                                <span>{props.contemplado.nom_estabelecimento}</span>
                            </div>
                        </div>

                        <div className="info-item">
                            <i className="fas fa-shopping-cart"></i>
                            <div>
                                <label>Data da Compra</label>
                                <span>{formatDate(props.contemplado.dat_venda)}</span>
                            </div>
                        </div>
                    </div>

                    {validImages.length > 0 && (
                        <div className="sorteado-images-section">
                            <h3 className="section-subtitle">Fotos do Sorteio</h3>
                            <div className={`sorteado-images-grid ${validImages.length === 1 ? 'single-image' : ''}`}>
                                {validImages.map((image, index) => (
                                    <div key={index} className="sorteado-image-card">
                                        <IMAGEM src={image.url_foto} alt={`Imagem ${index + 1}`} width={300} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>

                <div className="sorteado-detalhe-footer">
                    <button className="btn-close-sorteado" onClick={Close}>Fechar</button>
                </div>
            </div>
        </POPUP>

    );
}

export default DIALOGSORTEADODETALHE;